import { useEffect, useRef, useState } from "react";
import { getLoggedinUser } from "../../helpers/api_helper";

const getSessionToken = (session: any) => {
  if (typeof session === "string") return session;
  return session?.token || "";
};

const useProfile = () => {
  const userProfileSession = getLoggedinUser();
  const token = getSessionToken(userProfileSession);
  const [loading, setLoading] = useState(userProfileSession ? false : true);
  const [userProfile, setUserProfile] = useState(
    userProfileSession ? userProfileSession : null
  );

  useEffect(() => {
    const userProfileSession = getLoggedinUser();
    const token = getSessionToken(userProfileSession);
    setUserProfile(userProfileSession ? userProfileSession : null);
    setLoading(token ? false : true);
  }, []);


  return { userProfile, loading, token };
};
 function useDebounce<T extends (...args: any[]) => void>(callback: T, delay: number) {
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  return (...args: Parameters<T>) => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
    timerRef.current = setTimeout(() => {
      callback(...args);
    }, delay);
  };
}
 function toProperCase(str:string) {
  return str
    .toLowerCase()
    .replace(/(^|\s)\S/g, (letter) => letter.toUpperCase());
}
export { useProfile ,useDebounce,toProperCase};
